import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

export default function SearchInput({ placeholder = 'Search deals, merchants…', onSearch, style, ...props }) {
  return (
    <Search
      placeholder={placeholder}
      prefix={<SearchOutlined style={{ color: 'var(--df-text-muted, #8494A7)' }} />}
      enterButton="Search"
      size="large"
      onSearch={onSearch}
      aria-label={placeholder}
      style={{
        borderRadius: 10,
        ...style,
      }}
      {...props}
    />
  );
}
